<template>
  <div class="mb-4 mt-8 flex flex-row justify-center">
    <button
      class="btn"
      :class="{ 'load': busy }"
      :disabled="busy"
      :aria-disabled="busy"
      type="button"
      @click="$emit('updateProfile')"
      v-text="updateAccountText"
    />
  </div>
</template>

<script type="text/babel">
export default {
  name: 'UpdateProfileDetailsButton',
  props: {
    busy: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    updateAccountText() {
      return this.busy ? 'Updating...' : 'Update'
    },
  },
}
</script>
